<template>
  <div class="reward-types d-flex">
    <v-button :inactive="value !== 'percent'" size="xs-small" @click="$emit('input', 'percent')">{{ $t('components.Profile.rewardTypes.inPercent') }}</v-button>
    <v-button class="ml-1" :inactive="value !== 'fix'" size="xs-small" @click="$emit('input', 'fix')">{{ $t('components.Profile.rewardTypes.fixed') }}</v-button>
  </div>
</template>

<script>
import vButton from '@/ui/controls/vButton'

export default {
  props: {
    /**
     * @values percent, fix
     */
    value: {
      type: String,
      default: ''
    }
  },

  components: {
    vButton
  }
}
</script>

<style lang="scss">
</style>
